import PropTypes from "prop-types"
import React from "react"
import Section from "components/Layout/Section"
import SimpleHeader from "components/Layout/SimpleHeader"
import * as css from "./VsCards.module.css"

const PRESET_LABEL = "Preset"

function CardRow({ labelClass, label, text, textHtml }) {
  return (
    <div className={css.row}>
      <p className={`${css.label} ${labelClass}`}>
        <span className={css.labelDot} aria-hidden="true" />
        {label}
      </p>
      {textHtml ? (
        <div
          className={css.text}
          dangerouslySetInnerHTML={{ __html: textHtml }}
        />
      ) : (
        <p className={css.text}>{text}</p>
      )}
    </div>
  )
}

CardRow.propTypes = {
  labelClass: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  text: PropTypes.string,
  textHtml: PropTypes.string,
}

function VsCards({
  label,
  heading,
  description,
  competitorLabel = "Tableau",
  cards,
}) {
  return (
    <Section padding="extraLight">
      <SimpleHeader
        label={label}
        title={heading}
        subtitle={description}
        dash="vertical"
        narrow="both"
      />
      <div className={css.grid}>
        {cards?.map((card, index) => (
          <div key={`vs-card-${index}`} className={css.card}>
            <h3 className={css.cardHeading}>{card.heading}</h3>
            <CardRow
              labelClass={css.labelPreset}
              label={card.presetLabel || PRESET_LABEL}
              text={card.presetText}
              textHtml={card.presetTextHtml}
            />
            <CardRow
              labelClass={css.labelCompetitor}
              label={card.competitorLabel || competitorLabel}
              text={card.competitorText}
              textHtml={card.competitorTextHtml}
            />
          </div>
        ))}
      </div>
    </Section>
  )
}

VsCards.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  competitorLabel: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      presetLabel: PropTypes.string,
      presetText: PropTypes.string,
      presetTextHtml: PropTypes.string,
      competitorLabel: PropTypes.string,
      competitorText: PropTypes.string,
      competitorTextHtml: PropTypes.string,
    })
  ),
}

export default VsCards
